import { fork } from 'redux-saga/effects'
import * as project from './projectSaga'
import * as question from './questionSaga'
import * as auth from './authSaga'

export default function* rootSaga() {
  yield fork(project.runFetchProjectHandler)
  yield fork(question.runFetchQuestionHandler)
  yield fork(question.runPostAnswerHandler)
  yield fork(question.runFetchQuizResultHandler)
  yield fork(auth.runCreateParticipantHandler)
}
